import { render } from "./ReleaseNotice.vue?vue&type=template&id=0367bdaf"
import script from "./ReleaseNotice.vue?vue&type=script&lang=js"
export * from "./ReleaseNotice.vue?vue&type=script&lang=js"

import "./ReleaseNotice.vue?vue&type=style&index=0&id=0367bdaf&lang=scss"

import exportComponent from "E:\\DevWorkspaces\\WorkSpaces\\sts3.9.9\\ZhaoTong\\laborEmpWeb\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__